import React from 'react';
import Ev_Day_Class3_2023 from 'views/Ev_Day_Class3_2023';

const AccountGeneralPage = () => {
  return <Ev_Day_Class3_2023/>;
};

export default AccountGeneralPage;

// EnvironmentDay2023